import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-date-groupement',
    templateUrl: './dialog-date-groupement.component.html',
    styleUrls: ['./dialog-date-groupement.component.css'],
})
export class DialogDateGroupementComponent implements OnInit {
    details: any;
    tesisSpOpenDt = false;
    currentDate = new Date();
    time: Date;
    timedelai = true;
    isnotsaved = false;

    constructor(
        public dialogRef: MatDialogRef<DialogDateGroupementComponent, boolean>,
        @Inject(MAT_DIALOG_DATA)
            data: {
            data: any;
        }
    ) {
        this.details = data;
    }

    ngOnInit(): void {

    }

    respond(confirm: boolean) {
        this.dialogRef.close(confirm);
    }
}
